// src/paginas/NuestroEquipo.js
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import estebanImg from "../assets/esteban.jpg";
import ceciliaImg from "../assets/cecilia.jpg";

function NuestroEquipo() {
  const miembros = [
    {
      nombre: "Esteban",
      rol: "Arquitecto de desarrollo",
      descripcion:
        "Con más de 20 años de experiencia en el ámbito IT, Esteban es Analista de Sistemas, docente y especialista en reparación de PC y redes. Ha desarrollado soluciones en Salesforce, contando con 4 certificaciones que avalan su expertise. Además, es desarrollador Full Stack, dominando tecnologías como React, JavaScript, MongoDB y Node.js. Su enfoque integral y pasión por la tecnología lo convierten en un pilar fundamental para transformar ideas en soluciones digitales efectivas.",
      imagen: estebanImg,
    },
    {
      nombre: "Cecilia",
      rol: "Desarrolladora Full Stack",
      descripcion:
        "Formada en Educación IT, Cecilia es desarrolladora Full Stack con una sólida orientación al Back-End. Especializada en Node.js, MongoDB, React y JavaScript, aporta soluciones eficientes y escalables. Su compromiso con la calidad y la innovación la posiciona como una profesional clave en la creación de proyectos tecnológicos que responden a las necesidades actuales del mercado.​",
      imagen: ceciliaImg,
    },
  ];

  return (
    <Container style={{ padding: "60px 0" }}>
      <h2
        className="text-center mb-5"
        style={{ color: "#FFA500", fontWeight: "bold" }}
      >
        Conocé a nuestro equipo
      </h2>
      <Row className="justify-content-center">
        {miembros.map((miembro, idx) => (
          <Col
            key={idx}
            xs={12}
            sm={10}
            md={6}
            lg={4}
            className="mb-4 d-flex justify-content-center"
          >
            <Card className="h-100 shadow-sm" style={{ maxWidth: "350px" }}>
              <Card.Img
                variant="top"
                src={miembro.imagen}
                style={{ height: "350px", objectFit: "cover" }}
              />
              <Card.Body>
                <Card.Title>{miembro.nombre}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                  {miembro.rol}
                </Card.Subtitle>
                <Card.Text
                  style={{
                    fontSize: "0.95rem",
                    textAlign: "justify",
                  }}
                >
                  {miembro.descripcion}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default NuestroEquipo;
